import { CdkScrollable } from '@angular/cdk/scrolling';
import { Directive } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

/**
 * O2 Sheet Body Directive
 *
 * Scrollable body section for the sheet.
 * Automatically handles overflow with hidden scrollbar.
 * Takes up all available space between header and footer.
 *
 * Registers as a CDK scrollable so CDK features that need to know about
 * scroll containers work inside sheets — in particular drag-and-drop
 * auto-scrolling while dragging near the top/bottom edge of the body.
 *
 * Note: Uses global 'scrollbar-hide' utility class.
 *
 * Usage:
 * <div o2SheetBody>
 *   <!-- Your form or content here -->
 * </div>
 */
@Directive({
  selector: '[o2SheetBody]',
  standalone: true,
  hostDirectives: [CdkScrollable],
})
export class O2SheetBodyDirective {
  constructor() {
    classes(() => 'flex-1 overflow-y-auto scrollbar-hide');
  }
}
